<template>
  <div class="text-left">
    <p>{{this.getShort()}}</p>
  </div>
</template>

<script>
  export default {
    name: 'ShortText',
    props: ['row', 'column'],
    data: () => {
      return {}
    },
    methods: {
      getShort() {
        if (!this.row[this.column]) return '';
        if (this.row[this.column].length > 20) {
          return this.row[this.column].slice(0, 20) + '...';
        }
        return this.row[this.column];
      }
    }
  }
</script>
